import { render, staticRenderFns } from "./KakaoChennelList.vue?vue&type=template&id=497dc284"
import script from "./KakaoChennelList.vue?vue&type=script&lang=js"
export * from "./KakaoChennelList.vue?vue&type=script&lang=js"
import style0 from "./KakaoChennelList.vue?vue&type=style&index=0&id=497dc284&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports